import { useState } from "react";


const _props = {
    left: <></>,
    right: <></>
}

export function ChartPanel(props = _props) {

    const [show, setShow] = useState(true);

    const showHideChange = (display) => {
        setShow(display)
    }
    const icon=<svg xmlns="http://www.w3.org/2000/svg" width="8.115" height="8.454" viewBox="0 0 8.115 8.454">
    <g id="arrow-bar-up" transform="translate(-7.2 -4.497)">
            <path id="Path_496" data-name="Path 496" d="M15.917,7.756a.423.423,0,0,0,0-.6L13.381,4.622a.423.423,0,0,0-.6,0L10.247,7.157a.423.423,0,0,0,.6.6l2.237-2.237,2.237,2.238a.423.423,0,0,0,.6,0Z" transform="translate(-1.825)" fill="#585858" fillRule="evenodd" />
            <path id="Path_497" data-name="Path 497" d="M11.257,11.965a.423.423,0,0,0,.423-.423V6.048a.423.423,0,0,0-.845,0v5.494A.423.423,0,0,0,11.257,11.965ZM7.2,13.317a.339.339,0,0,1,.338-.338h7.438a.338.338,0,0,1,0,.676H7.538A.338.338,0,0,1,7.2,13.317Z" transform="translate(0 -0.704)" fill="#585858" fillRule="evenodd" />
    </g>
  </svg>
    return <div className="rc_homepage_widget">
        {show && <div className="doc-analytics-graphs ">
            <div className="chartLeft">
                {props.left}
            </div>
            <div className="chartRight">
                {props.right}
            </div>
        </div>}
        {!show && <div className="whiteSpaceBox"></div>}
        <div className="text-center graphAreaMain">
            <div className={"graphButton " + ( show ? 'Hide' : 'Show') } onClick={() => {
                showHideChange(!show)
            }}> {icon } {show ? 'Hide' : 'Show Graph'}</div>
        </div>
    </div>
}